import React from 'react';

import { useHeaderId } from '../../hooks/useHeaderId';

import * as classes from './style.module.scss';

interface Props {
  title: string;
  description?: string;
}

export const PageHeader: React.FC<Props> = ({ title, description }) => {
  const [getHeaderId] = useHeaderId();
  const [titleSlug] = getHeaderId(title);

  return (
    <>
      <h1 id={titleSlug}>{title}</h1>
      {description && <div className={classes.subheadline}>{description}</div>}
    </>
  );
};
